import axios from '@axios'

const routeLogin = 'login'
const routeLogout = 'logout'

export default {
  namespaced: true,
  state: {
    loading: false,
    lastError: null,
  },
  getters: {
    isLoading(state) {
      return state.loading
    },
    getError(state) {
      return state.lastError
    },
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value
    },
    setError(state, value) {
      state.lastError = value
    },
  },
  actions: {
    async run({ commit }, { credentials, request, validate }) {
      commit('setLoading', true)
      commit('setError', null)

      let token = null
      let result = null
      let loginData = null

      try {
        const loginResponse = await axios.post(routeLogin, credentials, { headers: { callbackerror: true } })
        loginData = loginResponse.data
        token = loginData?.authorization?.token

        if (!token) {
          throw new Error('Token de autorização não retornado')
        }

        if (validate) {
          validate(loginData)
        }

        result = await request(token, loginData)
      } catch (error) {
        commit('setError', error)
        throw error
      } finally {
        if (token) {
          try {
            await axios.post(routeLogout, null, {
              headers: {
                Authorization: `Bearer ${token}`,
                callbackerror: true,
              },
            })
          } catch (logoutError) {
            // Ignora erros de logout temporário
            // eslint-disable-next-line no-console
            console.warn('Erro ao encerrar sessão temporária', logoutError)
          }
        }
        commit('setLoading', false)
      }

      return result
    },
  },
}
